<template>
    <div class="support-group">
        <div class="support-item" v-if="showContent">
            <div class="problem-chevron" @click="change_content(1)" style="color: #0084FF">
                <i  class="ivu-icon ivu-icon-chevron-left"></i>
            </div>
            <div style="padding: 15px 0 15px 0;">
                <h3>{{problem_answer.title}}</h3>
                <p>
                    {{problem_answer.content}}
                </p>
            </div>
        </div>
        <div class="support-item" v-else>
            <div v-for="(item,index) in faq" :key="index" style="padding: 15px 0 15px 0;">
                <h3>{{item.title}}</h3>
                <p class="support-item-content">
                    {{item.content}}
                </p>
                <p class="text-primary" style="margin-top: 10px;" @click="fetchContent(item.id)">
                    {{$t('Services_mainpage_remain_to_be_solved')}} <Icon type="chevron-right"></Icon>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import Signature from '../../../lib/Signature'

    export default {
        data () {
            return {
                problem_answer: {},
                faq: [],
                showContent:false
            }
        },
        methods: {
            fetchContent (id) {
                let self = this
                const module = 'answer'
                let data = {}
                data.problem_id = id
                data.lang = this.$i18n.locale
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.get(process.env.BASEURL + module, {params: data}).then(function (resp) {
                    console.log(resp.data)
                    if (parseInt(resp.data.code) === 2000) {
                        self.showContent = true
                        self.problem_answer = resp.data.data.now_problem
                    }
                })
            },
            fetchData () {
                let data = {}
                const module = 'index/search/search'
                data.sub_time = Signature.timestamp()
                data.user_id = this.Local.getUserId()
                data.content = this.$route.query.q
                data.token = this.Local.getUserToken()
                data.sign = Signature.create(module, data.sub_time)
                data.lang = this.$i18n.locale
                this.$http.get(process.env.BASEURL + module, {
                    params: data
                })

                .then(function (resp) {
                    if (parseInt(resp.data.code) === 2000) {
                        this.faq = resp.data.data.faq_list
                        this.Local.set('faq_list_count', resp.data.data.faq_list.length)
                    }
                }.bind(this))
            },
            change_content (index,id) {
                this.showContent = false
            }
        },
        watch: {
            '$route': function (to, from) {
                this.fetchData()
            }
        },
        created () {
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
    @import "../../../scss/common";
    .support-group{
        .support-item {
            font-size: 16px;
            margin-bottom: 15px;
            h3 {
                font-size: 24px;
                color: #1F2D3D;
                font-weight: 500;
                line-height: 2;
            }
            .support-item-content {
                font-size: 18px;
                overflow : hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// SupportItem.vue?288334a7